
import { EntityID } from 'api/types/EntityID';
import { showErrorToast } from 'components/CustomAlerts/CustomToast';
import { DEFAULT_LIMIT_PAGINATION } from 'constants/appConstants';
import { Organismo } from 'dtos/organismo';
import React, { useCallback, useEffect, useState } from 'react';
import { findOrganismos } from 'services/organismos';

interface OrganismosListCtxValue
{
  isLoading: boolean;

  filterName: string;
  setFilterName: (filterName: string) => void;

  page: number;
  setPage: (page: number) => void;

  limit: number;
  setLimit: (limit: number) => void;

  cantidad: number;
  elementos: Organismo[];

  onOrganismoCreated: (organismo: Organismo) => void;

  onOrgamismoUpdated: (organismo: Organismo) => void;

  onOrgamismoDeleted: (organismoId: EntityID) => void;
}

interface OrganismosListCtxProviderProps
{
  children: React.ReactNode;
}

const OrganismosListCtx = React.createContext<OrganismosListCtxValue>({} as OrganismosListCtxValue);

export function OrganismosListCtxProvider({ children }: OrganismosListCtxProviderProps)
{
  const [ isLoading, setIsLoading ] = useState<boolean>(false);
  const [ filterName, setFilterName ] = useState<string>("");
  const [ page, setPage ] = useState<number>(0);
  const [ limit, setLimit ] = useState<number>(DEFAULT_LIMIT_PAGINATION);
  const [ cantidad, setCantidad ] = useState<number>(0);
  const [ elementos, setElementos ] = useState<Organismo[]>([]);

  const reload = useCallback(() =>
  {
    setIsLoading(true);

    findOrganismos({
      page,
      limit,
      nombre: filterName,
    })
    .then((data) =>
    {
      setPage(data.page);
      setCantidad(data.cantidad);
      setElementos(data.elementos);
    })
    .catch(() =>
    {
      showErrorToast("No fue posible cargar los organismos");
    })
    .finally(() =>
    {
      setIsLoading(false);
    });
  }, [page, limit, filterName]);

  useEffect(() =>
  {
    reload();

  }, [reload]);

  return <OrganismosListCtx.Provider value={{
    isLoading,

    filterName,
    setFilterName,

    page,
    setPage,

    limit,
    setLimit,

    cantidad,
    elementos,

    onOrganismoCreated: (newOrganismo: Organismo): void =>
    {
      reload();
    },

    onOrgamismoUpdated: (organismo: Organismo): void =>
    {
      reload();
    },

    onOrgamismoDeleted: (organismoId: EntityID): void =>
    {
      reload();
    },

  }}>
    {children}
  </OrganismosListCtx.Provider>
}

export function useOrganismosList()
{
  return React.useContext(OrganismosListCtx);
}
